/**
 * Bản tiếng Anh của `#top`. Mỗi chuỗi lấy từ thuộc tính `data-en` của CHÍNH node đó trong
 * `template.html` — không dịch mới.
 *
 * Danh từ riêng (`design-system`, `Atlas 4.0`, `Snowflake`, `JP`) giống hệt bản `vi`. Vẫn khai
 * lại đầy đủ chứ không dùng chung: hình dạng phải khớp, và một ngày nào đó bản `en` đổi mà bản
 * `vi` thì không.
 */

interface HeroMessage {
  readonly author: string;
  readonly time: string;
  readonly initials: string;
  readonly tint: 'brand' | 'success' | 'warn' | 'violet';
  readonly text: string;
}

const messages: readonly HeroMessage[] = [
  {
    author: 'Maya C.',
    time: '09:24',
    initials: 'MC',
    tint: 'warn',
    text: 'Token set v2 is ready — should we split radius into its own scale?',
  },
  {
    author: 'Jordan P.',
    time: '09:26',
    initials: 'JP',
    tint: 'brand',
    text: "Agreed. I'll open a topic so the main channel stays clean.",
  },
  {
    author: 'Ngọc L.',
    time: '09:31',
    initials: 'NL',
    tint: 'success',
    text: '@Quill summarise this thread into the release note.',
  },
];

interface SidebarChannel {
  readonly name: string;
  readonly icon: 'hash' | 'corner-down-right' | 'mic' | 'lock';
  readonly state: 'active' | 'nested' | 'idle';
  readonly badge?: string;
  readonly tag?: string;
}

interface SidebarAgent {
  readonly name: string;
  readonly initials: string;
  readonly tint: 'brand' | 'violet';
}

/* Tên channel và tên agent là danh từ riêng trong ảnh chụp sản phẩm — thiết kế KHÔNG gắn
   `data-en` cho chúng, tức chính nó cũng coi đây là thứ không dịch. Vẫn khai lại đầy đủ để hai
   bản cùng hình dạng. */
const channels: readonly SidebarChannel[] = [
  { name: 'design-system', icon: 'hash', badge: '4', state: 'active' },
  { name: 'tokens-v2', icon: 'corner-down-right', state: 'nested' },
  { name: 'design-standup', icon: 'mic', tag: 'LIVE', state: 'nested' },
  { name: 'q2-launch', icon: 'hash', badge: '7', state: 'idle' },
  { name: 'leadership', icon: 'lock', state: 'idle' },
  { name: 'sales-pipeline', icon: 'hash', state: 'idle' },
];

const agents: readonly SidebarAgent[] = [
  { name: 'Quill Analyst', initials: 'QA', tint: 'brand' },
  { name: 'Atlas DevOps', initials: 'AD', tint: 'violet' },
];

export const hero = {
  badge: 'Nexa — a NewEra Inc. product',
  ctaPrimary: 'Start free trial',
  ctaSecondary: 'Book a demo',
  note: 'Web + Mobile · Vietnamese–English · On-premise available',
  paneLabels: ['Show chat pane', 'Show kanban pane', 'Show AI assistant pane'],
  mock: {
    urlBar: 'app.nexa.vn/newera-inc',
    workspace: 'NewEra.Inc',
    jumpTo: 'Jump to…',
    groupChannels: 'CHANNELS',
    groupAgents: 'AI AGENTS',
    sidebar: { channels, agents },
    chat: {
      channel: 'design-system',
      members: '24 members',
      topics: ['tokens-v2', 'icon-audit', 'handoff'],
      messages,
      composer: 'Message #design-system',
    },
    kanban: {
      title: 'Q2 Launch — Atlas 4.0',
      sprintBadge: 'SPRINT 14',
      deadline: 'Ends in 6 days',
      columns: [
        {
          title: 'TO DO · 4',
          cards: ['Rollback runbook', 'Readiness board slide', 'QA sign-off sheet'],
        },
        { title: 'IN PROGRESS · 3', cards: ['Launch readiness report Q2', 'Pricing page v2'] },
        { title: 'REVIEW · 2', cards: ['Migration script'] },
        { title: 'DONE · 11', cards: ['Design QA pass'] },
      ],
      priority: 'HIGH',
      assignee: 'JP',
    },
    agent: {
      name: 'Quill Analyst',
      initials: 'QA',
      tools: 'SQL · Snowflake · Drive',
      ask: 'Compare Q2 pipeline against target and flag the risks.',
      reading: 'Reading 3 sources',
      sources: ['Snowflake · ANALYTICS.PROD', 'q2-forecast.xlsx', 'Launch Q2 (shared)'],
      answer:
        'Pipeline is at 86% of target. Two risks: enterprise deals slipping past the sprint window, and 3 blockers still open on Atlas 4.0.',
      actions: ['Create task', 'Post to #q2-launch'],
    },
  },
};
